import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, map } from 'rxjs';
import { ITema } from 'modelos/src';
import { TemasService } from './http/temas.service';

const STORAGE_KEY_DESACTIVADO = 'tema-overlay-desactivado-usuario';

@Injectable({ providedIn: 'root' })
export class TemaRuntimeService {
  private service = inject(TemasService);

  private activa$ = new BehaviorSubject<ITema | null>(null);
  private preview$ = new BehaviorSubject<ITema | null>(null);
  private desactivado$ = new BehaviorSubject<boolean>(this.leerDesactivado());

  /** Tema efectivo: preview gana sobre activa. Null si no hay nada. */
  public tema$: Observable<ITema | null> = combineLatest([
    this.activa$,
    this.preview$,
  ]).pipe(map(([a, p]) => p ?? a));

  /** Observable del flag de desactivación por usuario. */
  public desactivadoPorUsuario$: Observable<boolean> =
    this.desactivado$.asObservable();

  public async init() {
    try {
      const tema = await this.service.getActivaPublica();
      this.activa$.next(tema);
    } catch (e) {
      console.warn('No se pudo cargar tema activo:', e);
      this.activa$.next(null);
    }
  }

  public refresh() {
    return this.init();
  }

  public setPreview(tema: ITema | null) {
    this.preview$.next(tema);
  }

  public clearPreview() {
    this.preview$.next(null);
  }

  public overlayDesactivadoPorUsuario(): boolean {
    return this.desactivado$.value;
  }

  public setOverlayDesactivado(desactivado: boolean) {
    localStorage.setItem(
      STORAGE_KEY_DESACTIVADO,
      desactivado ? 'true' : 'false',
    );
    this.desactivado$.next(desactivado);
  }

  private leerDesactivado(): boolean {
    return localStorage.getItem(STORAGE_KEY_DESACTIVADO) === 'true';
  }
}
